import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';

@Component({
  selector: 'app-criteria-weights-tree-controls',
  imports: [Button, TooltipModule, TranslocoPipe],
  templateUrl: './criteria-weights-tree-controls.component.html',
  styles: [
    `
      :host ::ng-deep .p-button.tree-control-button {
        width: 2.25rem !important;
        height: 2.25rem !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CriteriaWeightsTreeControlsComponent {
  readonly zoomLabel = input.required<string>();
  readonly testId = input.required<string>();

  readonly zoomIn = output<void>();
  readonly zoomOut = output<void>();
  readonly resetView = output<void>();
}
